module.exports = __webpack_public_path__ + "static/media/WSRCA_logo.3f2b7bfb.png";